
function renderContent (title, content) {
  return $(
    '<div class="tiny-modal">' +
      '<div class="tiny-modal-overlay theme-bg-tertiary"></div>' +
      '<div class="tiny-modal-inner theme-text-main">' +
        '<div class="tiny-modal-header">' +
          '<h3>' + title + '</h3>' +
          '<button data-tiny-modal-close></button>' +
        '</div>' +
        '<div class="tiny-modal-content">' + content + '</div>' +
      '</div>' +
    '</div>');
}


//
// Tiny Modal
//

module.exports = function TinyModal ($host, config) {

  // Setup
  var title   = config.modalTitle;
  var content = config.modalContent;

  // Dom
  var $overlay = renderContent(config.modalTitle, config.modalContent);

  // Functions
  function show () {
    $overlay
      .show()
      .css('opacity', 0)
      .appendTo('body')
      .animate({ opacity: 1 }, 300);
  }

  function hide () {
    $overlay.animate({ opacity: 0 }, 300, function () { $(this).hide(); });
  }

  // Listeners
  $host.on('click', show);
  $overlay.on('click', '[data-tiny-modal-close]', hide);
  $(document).on('keydown', whichKey(27, hide));

  // Interface
  return {
    show: show,
    hide: hide
  };

};

